import { makeStyles } from "tss-react/mui";

interface IParams {
    selected?: boolean;
    disabledRadio?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => {
    const { selected, disabledRadio } = props;

    return {
        addAddonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        addonButtonImage: {
            width: 26,
            height: 26,
            fill: "none",
        },
        addonContainer: {
            width: "auto",
        },
        addonDescriptionContainer: {
            height: "100%",
            justifyContent: "center",
        },
        addonImageContainer: {
            display: "flex",
            flexDirection: "column",
            marginRight: theme.spacing(2),
        },
        addonPriceContainer: {
            alignItems: "center",
        },
        addonStatusContainer: {
            backgroundColor: theme.palette.background.main,
            height: "100%",
            textAlign: "center",
        },
        addonStatusInnerContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: theme.spacing(2),
            height: "-webkit-fill-available",
        },
        addonStatusLabel: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.background.main,
            height: "fit-content",
            padding: `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.2)}`,
            ".MuiChip-label": {
                padding: 0,
            },
        },
        centeredContainer: {
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
        },
        addonModalContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "normal",
            gap: theme.spacing(1),
        },
        addonModalButtonContainer: {
            marginTop: theme.spacing(2),
        },
        addressContainer: {
            backgroundColor: disabledRadio ? theme.palette.background.main : theme.palette.background.default,
            justifyContent: "flex-start",
            border: `1px solid ${!selected ? theme.palette.background.dark : theme.palette.primary.main}`,
            borderRadius: theme.shape.borderRadius * 3,
            padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
            cursor: "pointer",
            "&:hover": {
                backgroundColor: theme.palette.background.default,
            },
            "&:focus-visible, &:active": {
                border: `2px solid ${theme.palette.secondary.main}`,
                backgroundColor: theme.palette.background.dark,
            },
        },
    };
});
